import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { MatDialogRef, MatDialogContent, MatDialogActions, MatDialogTitle } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { TranslatePipe } from '@ngx-translate/core'

export type TemplateSaveAsDialogOutputData = {
  name: string
}

@Component({
  selector: 'app-template-save-as-dialog',
  imports: [CommonModule, FormsModule, MatDialogContent, MatDialogActions, MatDialogTitle, MatButton, MatFormFieldModule, MatInputModule, TranslatePipe],
  templateUrl: './template-save-as-dialog.html',
  styleUrl: './template-save-as-dialog.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class TemplateSaveAsDialog {
  templateName = ''
  dialogRef = inject(MatDialogRef<TemplateSaveAsDialog>)

  onSave() {
    const result: TemplateSaveAsDialogOutputData = {
      name: this.templateName.trim(),
    }
    this.dialogRef.close(result)
  }

  onCancel() {
    this.dialogRef.close(null)
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !this.isSaveDisabled) {
      event.preventDefault()
      this.onSave()
    }
  }

  get isSaveDisabled(): boolean {
    return this.templateName.trim() === ''
  }
}
